import { render, staticRenderFns } from "./TermsCondtions.vue?vue&type=template&id=059a81eb&scoped=true"
import script from "./TermsCondtions.vue?vue&type=script&lang=js"
export * from "./TermsCondtions.vue?vue&type=script&lang=js"
import style0 from "./TermsCondtions.vue?vue&type=style&index=0&id=059a81eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059a81eb",
  null
  
)

export default component.exports